import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

// globals
import * as constants from '../../globals/constants'
import * as TYPE from '../../globals/type'

// styles
import colors from '../../styles/colors'

// images
import BRImg from '../../assets/image/logo/ic-logo-br.svg'

function InfoMenu({ brandInfo, menuInfo }) {
  return (
    <>
      <Container>
        <LogoWrapper>
          {menuInfo?.logo && <img src={menuInfo?.logo} />}
        </LogoWrapper>
        <InfoWrapper>
          <NameProfile>{brandInfo.brandName}</NameProfile>
          <AreaProfile>{brandInfo.storeName}</AreaProfile>
          <StatusProfile>
            <IconStatus isOpen={brandInfo.isOpen} />
            <TextStatus>
              {brandInfo.isOpen ? '영업중' : '영업준비중'}
            </TextStatus>
          </StatusProfile>
        </InfoWrapper>
      </Container>
      <DivideLine />
    </>
  )
}

export default InfoMenu

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 0;

  @media ${(props) => props.theme.mobile} {
    padding: 70px 30px 30px;
    flex-direction: row;
  }
`

const LogoWrapper = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.W1};
  border: 1px solid ${colors.W3};
  margin-bottom: 13px;

  img {
    width: 65px;
    height: 65px;
  }
`

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  color: ${colors.BK};

  @media ${(props) => props.theme.mobile} {
    margin-left: 10px;
  }
`

const NameProfile = styled.div`
  font-weight: 400;
  margin-bottom: 7px;

  @media ${(props) => props.theme.mobile} {
    margin-bottom: 12px;
  }
`

const AreaProfile = styled.div`
  font-weight: 700;
  margin-bottom: 23px;

  @media ${(props) => props.theme.mobile} {
    margin-bottom: 18px;
  }
`

const StatusProfile = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
`

const IconStatus = styled.div`
  width: 15px;
  height: 15px;
  border-radius: 7.5px;
  background-color: ${(props) =>
    props.isOpen ? `${colors.subG}` : `${colors.D3}`};
  margin-right: 10px;
`

const TextStatus = styled.div`
  color: ${colors.BK};
  font-size: 14px;
`

const DivideLine = styled.div`
  height: 1px;
  margin-bottom: 30px;
  background-color: ${colors.G3};

  @media ${(props) => props.theme.tablet} {
    height: 5px;
    margin-bottom: 36px;
  }

  @media ${(props) => props.theme.tablet} {
    margin-bottom: 16px;
  }
`
